var fontSizes = {
  xsmall: '10px',
  small: '12px',
  base: '14px',
  medium: '16px',
  large: '18px',
  xlarge: '24px',
  xxlarge: '28px',
  xxxlarge: '38px'
};
var fontHeights = {
  lineHeight: '2'
};
var fontWeights = {
  heavy: 900,
  bold: 700,
  demi: 600,
  medium: 500,
  normal: 400,
  light: 300,
  thin: 100
};
export default {
  // Type and Style
  fontFamily: 'AvenirNext',
  // Standard Sizes
  size: fontSizes,
  weight: fontWeights,
  lineHeights: fontHeights,
  // Paragraphs
  headline: fontSizes.xlarge,
  subheader: fontSizes.medium,
  title: fontSizes.large
};